import 'signer-app/css-modules.d';
import 'signer-app/asset-imports.d';
import 'signer-app/is-storybook.d';
import 'signer-app/typings.d';
import type { Field, FieldTypes } from 'signer-app/types/editor-types';
import { AutoFillType } from 'js/sign-components/generated/types/HelloRequest';
import { SignerAppFeatureFlags } from 'signer-app/context/feature-flags';
import { SignatureRequest } from 'signer-app/signer-signature-document/types';
import {
  SignerID,
  SignerInfo,
  SignerMap,
} from 'signer-app/signer-preview/signer-dropdown';

export { default as SignatureProviderIntercept } from 'signer-app/signature-modal/signature-modal-context/signature-provider-intercept';
export {
  SignatureModalContextProvider,
  type SignatureModalContext,
  type SignatureModalTab,
} from 'signer-app/signature-modal/signature-modal-context/context';
export {
  signerContext,
  default as SignerContext,
} from 'signer-app/signer-signature-document/context';
export {
  default as Document,
  useZoomContextFromPageContainer,
} from 'signer-app/signature-request/document';

export {
  type DocumentAddress,
  type ScreenPosition,
  type Origin,
  type ZoomContextShape,
  type SignatureRequestContextShape,
  signatureRequestContext,
  useSignatureRequestContext,
  zoomContext,
  useZoomContext,
  ContextCapture,
  clampZoom,
  SignatureRequestContext,
} from 'signer-app/signature-request/context';
export {
  SignatureWorkflow,
  SignerExperience,
} from 'signer-app/signer-experience/signer-experience';

export { default as SignerDocument } from 'signer-app/signer-signature-document/document';
export { AccessibleDocument } from 'signer-app/signer-signature-document/accessible-document';

export { mockSignerAppClient } from 'signer-app/signer-app-client/mock-signer-app-client';
export { SignerDropdown } from 'signer-app/signer-preview/signer-dropdown';
export { SignerPreviewDocument } from 'signer-app/signer-preview/signer-preview-document';
export { SignerPreviewExperience } from 'signer-app/signer-preview/signer-preview-experience';
export { default as SignerApp, dummyEmbeddedData } from 'signer-app/signer-app';
export { NotificationBannerProvider } from 'signer-app/parts/notifications/notification-banners';

export type { WhiteLabelStyles } from 'signer-app/white-labeling/types';
export {
  defaultWhiteLabelStyles,
  themes,
} from 'signer-app/white-labeling/themes';

export {
  FieldTypes,
  AutoFillType,
  SignerAppFeatureFlags,
  SignatureRequest,
  SignerMap,
  SignerID,
  Field,
  SignerInfo,
};
export { TimestampLine } from './signature-request/display-field/signature-components/timestamp-line';
